import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const datacenterRouter: Array<RouteRecordRaw> = [
    {
        path: '/datacenter',
        name: '数据可视化',
        component: Layout,
        meta: { title: '数据可视化', icon: 'icon-database', alwaysShow: true },
        children: [
            {
                path: 'member',
                name: '会员数据统计',
                component: () => import('@/views/datacenter/Member.vue'),
                meta: { title: '会员数据统计' }
            },
            // {
            //     path: 'merchant',
            //     name: '商户数据统计',
            //     component: () => import('@/views/datacenter/Merchant.vue'),
            //     meta: { title: '商户数据统计', keepAlive: true, depth: 30 }
            // },
            {
                path: 'supplier-data',
                name: '销售额统计',
                component: () => import('@/views/board-data/SupplierData.vue'),
                meta: { title: '销售额统计', keepAlive: true, depth: 30 }
            },
            {
                path: 'saas-channel-data',
                name: '渠道数据统计',
                component: () => import('@/views/board-data/SaasChannelData.vue'),
                meta: { title: '渠道数据统计' }
            },   
            {
                path: 'general-control-data',
                name: '总控台数据',
                component: () => import('@/views/board-data/GeneralControlData.vue'),
                meta: { title: '总控台数据' }
            },
            {
                path: 'merchant-data',
                name: '数据看板',
                component: () => import('@/views/board-data/MerchantData.vue'),
                meta: { title: '数据看板' }     
            },  
            {
                path: 'channel-data',
                name: '渠道数据看板',
                component: () => import('@/views/board-data/ChannelData.vue'),
                meta: { title: '渠道数据看板' }     
            },
            {
                path: 'channel-product-data',
                name: '对接全量商品',
                component: () => import('@/views/board-data/ChannelProductData.vue'),
                meta: { title: '对接全量商品' }     
            },
            {
                path: 'channel-product-data-pre-export',
                name: '对接全量商品预导出',
                component: () => import('@/views/board-data/ChannelProductDataPreExport.vue'),
                meta: { title: '对接全量商品预导出' }     
            },
        ]
    }
]

export default datacenterRouter